import {
    Button,
    Card,
    Col,
    Collapse,
    DatePicker,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Pagination,
    Row,
    Select,
    Space,
    Table,
    Tag
} from "antd";
import {useEffect, useState} from "react";
import CommonFunction from "../../../../util/CommonFunction";
import {EyeOutlined} from "@ant-design/icons";
import dayjs from "dayjs";
import {CHANGE_REQUEST_RECORD_STATUS, NOT_AVAILABLE, YYYY_MM_DD, YYYY_MM_DD_HH_MM} from "../../../../util/Constants";
import {AddressDto} from "../../../../dto/AddressDto";
import {MSG_FAILED_TO_FETCH_CONTACT_CHANGE_DETAILS_HISTORY_ERROR} from "../../../../util/Messages";
import customerChangeRequestAdminService from "../../../../service/customerChangeRequestAdminService";
import ErrorHandler from "../../../../util/ErrorHandler";
import {ChangeRequestFilterDto} from "../../../../dto/admin/ChangeRequestFilterDto";
import {ContactDetailDto} from "../../../../dto/ContactDetailDto";
import TextArea from "antd/es/input/TextArea";

const {Panel} = Collapse;
const {RangePicker} = DatePicker;

const ContactDetailChangeHistoryComp = () => {

    const [contactDetailChangeHistoryList, setContactDetailChangeHistoryList] = useState<AddressDto[]>()
    const [loading, setLoading] = useState<boolean>(false);
    const [isRejected, setRejected] = useState<boolean>(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 10,
    });

    const [filter, setFilter] = useState<ChangeRequestFilterDto>({
        recordStatus: null,
        submittedDateTo: null,
        submittedDateFrom: null,
        cin: null,
        page: 1,
        size: 10,
        sort: ['createdDate', 'desc']
    });
    const [form] = Form.useForm();

    const [isModalOpen, setIsModalOpen] = useState(false);


    const handleCancel = () => {
        setIsModalOpen(false);
        resetModalFormFields();
    };

    const resetModalFormFields = () => {
        form.resetFields()
    }

    useEffect(() => {
        fetchAllContactChangeHistoryList(pagination.current, pagination.pageSize, filter)

    }, []);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'CIN',
            dataIndex: 'cin',
            key: 'cin',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            key: 'createdBy',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Created Date Time',
            dataIndex: 'createdDate',
            key: 'createdDate',
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Modified By',
            dataIndex: 'lastModifiedBy',
            key: 'lastModifiedBy',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Modified Date Time',
            dataIndex: 'lastModifiedDate',
            key: 'lastModifiedDate',
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Status',
            dataIndex: 'recordStatus',
            key: 'recordStatus',
            align: 'center',
            render: (text: any, rec: any) => {
                return (
                    <Tag className={'drl-tbl-tag'}
                         color={getColor(text)} key={text}>
                        {text.toUpperCase()}
                    </Tag>
                )
            }
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (rec: any) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            onClick={() => fetchContactChangeHistoryDetail(rec.cin, rec.id)}
                            icon={<EyeOutlined/>}>View</Button>
                </Space>
            ),
        },
    ];

    const showModal = (record: ContactDetailDto) => {
        setFormValue(record)

    };

    const setFormValue = (contactDetailDto: ContactDetailDto) => {
        setRejected("REJECTED" == contactDetailDto.recordStatus)
        form.setFieldsValue({
            email: contactDetailDto.email,
            homePhoneNumber: contactDetailDto.homePhoneNumber,
            officePhoneNumber: contactDetailDto.officePhoneNumber,
            faxNumber: contactDetailDto.faxNumber,
            mobileNumber: contactDetailDto.mobileNumber,
            rejectReason: contactDetailDto.rejectReason
        })
        setIsModalOpen(true);
    }


    const getColor = (identificationSourceType: string) => {
        switch (identificationSourceType) {
            case CHANGE_REQUEST_RECORD_STATUS.ACCEPTED: {
                return 'green';
            }
            case CHANGE_REQUEST_RECORD_STATUS.SUBMITTED: {
                return '#faad14';
            }
            case CHANGE_REQUEST_RECORD_STATUS.REJECTED: {
                return '#cf1322';
            }
            case CHANGE_REQUEST_RECORD_STATUS.CANCELLED: {
                return '#dfd3d4';
            }
        }
    }
    const handlePaginationChange = (page: number, pageSize: number) => {
        fetchAllContactChangeHistoryList(page, pageSize, filter);
    };

    const fetchAllContactChangeHistoryList = (page: number, pageSize: number, filterDto: ChangeRequestFilterDto) => {
        setLoading(true)

        filterDto.page = page - 1;
        filterDto.size = pageSize;

        customerChangeRequestAdminService.contactChangeRequestHistory(filterDto).then((res => {
            if (res.data !== null && res.data.results) {
                let results = res.data.results;
                console.log(results)
                setContactDetailChangeHistoryList(results.requestAdminHistoryDtos)
                setPagination({
                    current: results.page + 1, // Adjusting to be 1-based index
                    pageSize: results.size,
                    total: results.allCount,
                });
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_CONTACT_CHANGE_DETAILS_HISTORY_ERROR).then();
            }
        })).catch((reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }
    const fetchContactChangeHistoryDetail = (cin: string, id: number) => {
        setLoading(true)

        customerChangeRequestAdminService.getContactChangeRequestDetails(cin, id).then((res => {
            if (res.data !== null && res.data.results) {
                showModal(res.data.results)
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_CONTACT_CHANGE_DETAILS_HISTORY_ERROR).then();
            }
        })).catch((reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const onReset = () => {
        form.resetFields();
        let filterDto: ChangeRequestFilterDto = {
            cin: null,
            recordStatus: null,
            submittedDateFrom: null,
            submittedDateTo: null,
            page: 1,
            size: pagination.pageSize,
            sort: filter.sort
        }
        setFilter(filterDto);
        setPagination({
            ...pagination,
            current: 1,
        });
        fetchAllContactChangeHistoryList(1, pagination.pageSize, filterDto);
    }
    const onFilter = (values: any) => {

        let submittedDateFrom = null
        let submittedDateTo = null

        if (values.createdDate) {
            submittedDateFrom = values.createdDate[0].format(YYYY_MM_DD)
            submittedDateTo = values.createdDate[1].format(YYYY_MM_DD)
        }

        let filterDto: ChangeRequestFilterDto = {
            cin: checkUndefined(values.cin),
            recordStatus: values.recordStatus,
            submittedDateFrom: submittedDateFrom,
            submittedDateTo: submittedDateTo,
            page: 1,
            size: pagination.pageSize,
            sort: filter.sort
        }
        setFilter(filterDto);
        fetchAllContactChangeHistoryList(1, pagination.pageSize, filterDto);
    }
    const checkUndefined = (value: any) => {
        return value == undefined || value == "" ? null : value
    }


    return (
        <>
            <Row gutter={[24, 12]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Collapse className={'margin_bottom_20'}>
                        <Panel header="Filter History" key="1">
                            <Form
                                layout={"vertical"}
                                form={form}
                                onFinish={onFilter}
                            >
                                <Row gutter={[16, 0]}>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="cin" label="CIN">
                                            <Input placeholder={'Enter CIN'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="recordStatus" label="Status">
                                            <Select style={{width: '100%'}} defaultValue="All"
                                                    options={[
                                                        {value: null, label: 'All'},
                                                        {value: 'ACCEPTED', label: 'Accepted'},
                                                        {value: 'REJECTED', label: 'Rejected'},
                                                        {value: 'CANCELLED', label: 'Cancelled'}]}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item label="Created Date" name="createdDate">
                                            <RangePicker placeholder={["From Date", "To Date"]}
                                                         style={{width: '100%'}}/>

                                        </Form.Item>
                                    </Col>

                                </Row>
                                <Row gutter={[16, 0]}>
                                    <Col span={24}>
                                        <Space style={{float: 'right'}}>
                                            <Button style={{
                                                width: 120,
                                                marginRight: 8
                                            }} onClick={onReset}>Reset</Button>
                                            <Button type="success"
                                                    htmlType="submit"
                                                    style={{
                                                        width: 120,
                                                        background: "#FF7400",
                                                        color: "white",
                                                    }}>Filter</Button>
                                        </Space>
                                    </Col>
                                </Row>
                            </Form>
                        </Panel>
                    </Collapse>
                </Col>
                <Col span={24}>
                    <Table columns={columns} dataSource={contactDetailChangeHistoryList} pagination={false}
                           loading={loading}
                           scroll={{x: 'max-content'}}/>
                    <br/>
                    <Space style={{float: 'right'}}>
                        <Pagination
                            total={pagination.total ?? 0}
                            showTotal={(total: number) => `Total ${total} items`}
                            defaultPageSize={10}
                            defaultCurrent={pagination.current}
                            current={pagination.current}
                            onChange={handlePaginationChange}
                        />
                    </Space>
                </Col>
            </Row>
            <Modal title="Contact Details Update Request History"
                   className={'modal-body-scroll-only disabled-data-show-inputs-container'}
                   open={isModalOpen}
                   footer={null}
                   onCancel={handleCancel}
                   width={800}
                   centered
                   style={{top: 20, paddingBottom: 20}}
                   destroyOnClose={true}
                   maskClosable={false}>
                <Row gutter={[24, 12]} className={'form-item-mb-12 modal-body-scroll-only-main-row'}
                     style={{marginTop: 18}}>
                    <Col span={24}>
                        <Card title="Contact Details" size={'small'}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                            >
                                <Row gutter={[12, 0]}>
                                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Mobile Number"
                                            name={"mobileNumber"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Fax Number"
                                            name={"faxNumber"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Office Phone Number"
                                            name={"officePhoneNumber"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Residential Phone Number"
                                            name={"homePhoneNumber"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={12} xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Form.Item
                                            label="Email"
                                            name={"email"}>
                                            <Input disabled/>
                                        </Form.Item>
                                    </Col>
                                    {isRejected ?
                                        <>
                                            <Divider style={{marginBottom: 12}}></Divider>

                                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <Form.Item

                                                    name={"rejectReason"}
                                                    label={"Reject Reason"}>
                                                    <TextArea disabled bordered={true}/>
                                                </Form.Item>
                                            </Col>
                                        </> : <></>}

                                </Row>
                            </Form>
                        </Card>
                    </Col>
                </Row>

            </Modal>

        </>
    )
}
export default ContactDetailChangeHistoryComp;